!((document, Drupal, $) => {
  'use strict';

  Drupal.behaviors.homeslide2020 = {
    attach: function (context) {

      function setVideoBg(homeslides) {
        homeslides.each(function () {
          const slideId = $(this).data('slide-id');
          const gameId = $(this).data('game-id');
          const options = {
            muted: true,
            autoplay: true,
            controls: false,
            loop: true,
            fluid: true,
            background: true
          };

          let player = videojs('player' + gameId + '-' + slideId, options);
          player.play();

          // Set Mutation Observer
          let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              const el = mutation.target;

              if (el.classList.contains('slick-active')) {
                if (player.paused()) {
                  player.play();
                }
              }
              else {
                if (player.currentTime() > 1) {
                  player.pause();
                }
              }

            });

          });
          const config = {
            attributes: true, childList: false, subtree: false,
            attributeOldValue: true,
            attributeFilter: ['class']
          };

          observer.observe(this.closest('.homeslider-slice'), config);
        });
      }



      (function () {
        var throttle = function (type, name, obj) {
          obj = obj || window;
          var running = false;
          var func = function () {
            if (running) {
              return;
            }
            running = true;
            requestAnimationFrame(function () {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
            });
          };
          obj.addEventListener(type, func);
        };

        /* init - you can init any event */
        throttle('resize', 'optimizedResize');
      })();


      function isBgDefined(el) {
        let bg = $(el).css('background-image');
        if (bg !== 'none') {
          let regex = /(url\(["|'])(.*?)(["|']\))/gm;
          let match = regex.exec(bg);
          if (match) {
            return match[2];
          }
        }
        return false;
      }

      function toggleHeaderBackground(el, desktopBackground, mobileBackground) {
        let bgDefined = isBgDefined(el);
        if (window.innerWidth < 860 && mobileBackground) {
          if (!bgDefined || bgDefined !== mobileBackground) {
            el.css({
              'background-image': 'url(' + mobileBackground + ')'
            });
          }
        }
        else {
          if (!bgDefined || bgDefined !== desktopBackground) {
            el.css({
              'background-image': 'url(' + desktopBackground + ')'
            });
          }
        }
      }

      function setBg(homeslides) {
        homeslides.each(function() {
          let desktopBackground = $(this).data('header-bg');
          let mobileBackground = $(this).data('mobile-header-bg');
          toggleHeaderBackground($(this), desktopBackground, mobileBackground);
          $(this).addClass('elca-behavior-processed');
        });
      }


      let videoHomeslides = $('.homeslide__video_bg:not(.elca-behavior-processed)', context);
      setVideoBg(videoHomeslides);


      let homeslides = $('.homeslide__bg:not(.elca-behavior-processed)', context);
      setBg(homeslides);


      window.addEventListener('optimizedResize', function () {
        setVideoBg(videoHomeslides);
        setBg(homeslides);
      });

    }
  };
})(document, Drupal, jQuery);

